export var AndroidBackHandler = function AndroidBackHandler(_ref) {
  var children = _ref.children;
  return children || null;
};